import React from 'react';
import './HomeSection.css';

const HomeSection = () => {
  return (
    <section id="home" className="section home-section">
      <div className="content">
        
        {/* --- Link do WhatsApp atualizado para o número do Hotel Plaza --- */}
        <a href="https://wa.me/5535988179138" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
          Faça sua reserva
        </a>
      </div>
    </section>
  );
};

export default HomeSection;